import axios from "axios";
import apiURL from "../apiURL";


interface IGetUser {
    token: string;
    value: string;
}

const baseURL = apiURL();

const CheckIDCode = async (props: IGetUser): Promise<number> => {
    try {
        const token = props.token;
        const response = await axios.get<number>(
            `${baseURL}Marketer/checkIDCode?idCode=${props.value}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (error) {
        // Handle the error here
        console.error('Error checking for duplicates:', error);
        throw error;
    }
};

export default CheckIDCode;
